module.exports = __webpack_public_path__ + "img/雪山4_1.e103d9a1.jpg";